<!-- <banner-feedback></banner-feedback> -->
<!-- <banner-rare-disease-day></banner-rare-disease-day> -->
<!-- <banner-shutdown></banner-shutdown> -->
<!-- <banner-under-review></banner-under-review> -->
<app-scroll-to-top class="d-print-none"></app-scroll-to-top>

<div class="d-none d-print-block print-document-logo">
    <img class="d-block img-fluid" src="/assets/GARD_Logo.svg" alt="Genetic and Rare Diseases Information Center" />
</div>

<router-outlet></router-outlet>
